export default __webpack_public_path__ + "static/media/5.d6245498.txt";